(function (window, document, $) {

    $(document).ready(function () {

        'use strict';

        // Typekit =====================================================================================================

        Typekit.load({ async: true });


        // AJAX Request pooling ========================================================================================

        window.xhrPool = [];
        window.xhrPool.abortAll = function () {
            $(this).each(function (i, jqXHR) {
                jqXHR.abort();
                window.xhrPool.splice(i, 1);
            });
        };
        $.ajaxSetup({
            beforeSend: function (jqXHR) {
                window.xhrPool.push(jqXHR);
            },
            complete: function (jqXHR) {
                var i = window.xhrPool.indexOf(jqXHR);
                if (i > -1) {
                    window.xhrPool.splice(i, 1);
                }
            }
        });

        // Custom gallery popup ========================================================================================
        /*
        $("a[data-rel^='prettyPhoto']").prettyPhoto({
            hook: 'data-rel',
            social_tools: false,
            horizontal_padding: 20,
            opacity: 0.8,
            deeplinking: false
        });*/


        $(document).on( "wpgu-favorite-btn-clicked", function( e, button ) {
            if($(button).hasClass('selected')) {
                // do mojs animation on heart icon
                var id = $(button).data('wpgu-favorite-id');
                window.doHeartAnimation(".video-fav-button-" + id);

                // change text next to heart icon in single-video
                $(".single-video .favorite-text").html("Verwijder uit favorieten");
            } else {
                // if button has been unselected reset text
                $(".single-video .favorite-text").html("Bewaar als favoriet");
            }
        });

        $(document).on("wpgu-favorites-marked-selected", function() {
            if ($('.single-video').length && $('.video-fav-button-single.selected').length) {
                // change text next to heart icon in single-video
                $(".single-video .favorite-text").html("Verwijder uit favorieten");
            }
        });

        $(document).on('click', '[data-wpgu-onboarding-close]', function(e) {
            $('[data-onboarding-section]').addClass('d-none');
        });
    });

}(window, document, jQuery));
